import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type KartePlannerCommentFormAvailabilityFragment = { __typename?: 'KartePlannerCommentAvailability', availability: boolean, unavailableReason?: Types.KartePlannerCommentUnavailableReason | null };

export type KartePlannerCommentFormViewerFragment = { __typename?: 'Viewer', plan: Types.Plan };

export const KartePlannerCommentFormAvailabilityFragmentDoc = gql`
    fragment KartePlannerCommentFormAvailability on KartePlannerCommentAvailability {
  availability
  unavailableReason
}
    `;
export const KartePlannerCommentFormViewerFragmentDoc = gql`
    fragment KartePlannerCommentFormViewer on Viewer {
  plan
}
    `;